module.exports = __webpack_public_path__ + "static/media/NoirPro-Light.25188312.woff2";